import {
  BarController, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, LineElement, LogarithmicScale, PointElement, Title,
  Tooltip
} from 'chart.js';
import React, { Component, Fragment } from 'react';
import { Bar } from 'react-chartjs-2';
import './graphic-styles.scss';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarController,
  BarElement,
  LogarithmicScale,
)

interface GraphicProps {
  data: any;
  currentGraphic: string;
}

export default class GraphicComponent extends Component<GraphicProps> {
  render() {
    const { currentGraphic, data } = this.props;
    return (
      <Fragment>
        <div className="graph-container">
          <Bar
            data={{ 
              datasets: data.datasets,
              labels: data.labels
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  enabled: false,
                },
              },
              maintainAspectRatio: false,
              scales: {
                yAxes: {
                  min: 0,
                  max: currentGraphic.includes('berpo') ? -10 : 80,
                  type: currentGraphic.includes('berpo') ? 'logarithmic' : 'linear',
                  ticks: {
                    autoSkip: true,
                    callback(value: any) {
                      if (currentGraphic.includes('berpo')) {
                        if (value % 1 === 0) {
                          if (value === 0) {
                            return value;
                          }  
                          return (value = `1e-${value}`);
                        }
                        return
                      }
                      return value;
                    }
                  },
                },
              },
            }}
          />
        </div>
      </Fragment>
    );
  }
}
